module.exports = __webpack_public_path__ + "img/logo-3.a0d21168.jpg";